

export function sortByDate<T>(a: T, b: T, orientation: 'asc' | 'desc', key: keyof T): number {
  const dateA = new Date(a[key] as unknown as string);
  const dateB = new Date(b[key] as unknown as string);

  if (orientation === 'asc') {
    return dateB.getTime() - dateA.getTime();
  } else {
    return dateA.getTime() - dateB.getTime();
  }
}

export function sortByNumber<T>(a: T, b: T, orientation: 'asc' | 'desc', key: keyof T): number {
  if (orientation === 'asc') {
    return (b[key] as number) - (a[key] as number);
  } else {
    return (a[key] as number) - (b[key] as number);
  }
}

export function sortByString<T>(a: T, b: T, orientation: 'asc' | 'desc', key: keyof T): number {
  if (orientation === 'asc') {
    return String(b[key]).localeCompare(String(a[key]));
  } else {
    return String(a[key]).localeCompare(String(b[key]));
  }
}